/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NftControllerDtoNftGenerateStartCreatingRequest model module.
 * @module model/NftControllerDtoNftGenerateStartCreatingRequest
 * @version 1.0
 */
class NftControllerDtoNftGenerateStartCreatingRequest {
    /**
     * Constructs a new <code>NftControllerDtoNftGenerateStartCreatingRequest</code>.
     * @alias module:model/NftControllerDtoNftGenerateStartCreatingRequest
     */
    constructor() { 
        
        NftControllerDtoNftGenerateStartCreatingRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftControllerDtoNftGenerateStartCreatingRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftControllerDtoNftGenerateStartCreatingRequest} obj Optional instance to populate.
     * @return {module:model/NftControllerDtoNftGenerateStartCreatingRequest} The populated <code>NftControllerDtoNftGenerateStartCreatingRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftControllerDtoNftGenerateStartCreatingRequest();

            if (data.hasOwnProperty('generateNo')) {
                obj['generateNo'] = ApiClient.convertToType(data['generateNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftControllerDtoNftGenerateStartCreatingRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftControllerDtoNftGenerateStartCreatingRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} generateNo
 */
NftControllerDtoNftGenerateStartCreatingRequest.prototype['generateNo'] = undefined;






export default NftControllerDtoNftGenerateStartCreatingRequest;

